
/**
 * 1. 精准判断是否为对象数组（数组内所有元素均为有效普通对象）
 * @param {*} value - 待判断的值
 * @param {boolean} [allowEmpty=true] - 是否允许空对象数组（[]），默认允许
 * @returns {boolean} 是对象数组返回true，否则返回false
 */
function isObjectArray(value, allowEmpty = true) {
    // 第一步：先判断是否为数组
    if (!Array.isArray(value)) {
      return false;
    }
  
    // 第二步：处理空数组（根据配置决定是否视为对象数组）
    if (value.length === 0) {
      return allowEmpty;
    }
  
    // 第三步：判断数组中每一个元素是否为有效普通对象（非null、非数组、纯对象）
    return value.every(item => {
      return typeof item === 'object' && item !== null && !Array.isArray(item);
    });
  }
  /**
 * 2. 遍历对象，仅将对象数组属性转为JSON，其他属性保持原值（不修改原对象）
 * @param {Object} obj - 待处理的目标对象
 * @param {boolean} [format=true] - 是否格式化JSON（2空格缩进），默认开启
 * @param {boolean} [allowEmptyObjectArray=false] - 是否允许空对象数组转JSON
 * @returns {Object} 处理后的新对象
 */
function convertOnlyObjectArrayToJson(obj, format = true, allowEmptyObjectArray = false) {
    // 入参校验：非有效对象直接返回，避免报错
    if (typeof obj !== 'object' || obj === null) {
      console.warn('入参不是有效对象，无法进行处理');
      return obj;
    }
    const newObj = {};
    // 仅遍历对象的自有可枚举属性，避免处理继承属性
    Object.keys(obj).forEach(key => {
      const value = obj[key];
      // 仅对对象数组进行JSON转换，其他属性保持原值
      if (isObjectArray(value, allowEmptyObjectArray)) {
        try {
          newObj[key] = JSON.stringify(value);
        } catch (e) {
          console.error(`属性${key}对应的对象数组转JSON失败：`, e.message);
          newObj[key] = value; // 转换失败时保留原值
        }
      } else {
        newObj[key] = value;
      }
    });
    return newObj;
  }
const object = {
    /**
     * 提取两个对象所有交集键对应的第二个对象值（不依赖第一个对象的键范围）
     * @param {Object} obj1 - 第一个对比对象
     * @param {Object} obj2 - 第二个对比对象
     * @returns {Object} 第二个对象的交集键值
     */
    getSecondObjIntersectionValues (obj1, obj2){
        if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
        console.error('参数必须为对象');
        return {};
        }
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        // 找两个对象的交集键
        const commonKeys = keys1.filter(key => keys2.includes(key));
        const result = {};
        commonKeys.forEach(key => {
        result[key] = obj2[key];
        });
        return result;
    },
    
    /**
     * 将对象中值含逗号的字段转为数组（支持嵌套对象、空值、全空格处理）
     * @param {Object} obj - 待处理的对象
     * @param {Boolean} trim - 是否去除数组元素首尾空格（默认true）
     * @param {Boolean} skipEmpty - 是否跳过空值/纯空格值（默认false，空值转为空数组）
     * @returns {Object} 处理后的新对象
     */
    convertCommaValueToArray (obj, trim = true, skipEmpty = false){
        // 非对象直接返回（容错）
        if (typeof obj !== 'object' || obj === null) {
        console.warn('参数必须为非空对象');
        return obj;
        }
        const result = {};
        // 遍历对象所有键
        Object.keys(obj).forEach(key => {
        const value = obj[key];
        // 嵌套对象递归处理
        if (typeof value === 'object' && value !== null) {
            result[key] = this.convertCommaValueToArray(value, trim, skipEmpty);
            return;
        }
        // 非字符串类型直接保留原值
        if (typeof value !== 'string') {
            result[key] = value;
            return;
        }
        // 去除首尾空格（可选）
        const processedValue = trim ? value.trim() : value;
        // 跳过空值（可选）
        if (skipEmpty && processedValue === '') {
            result[key] = '';
            return;
        }
    
        // 含逗号则分割为数组，否则保留原值（空值转为空数组）
        if (processedValue.includes(',')) {
            result[key] = processedValue.split(',').map(item => trim ? item.trim() : item);
        } else {
            result[key] = processedValue === '' ? [] : processedValue;
        }
        });
        return result;
    },
    /**
     * 俩个对象合并只合并第一个存在的key
     */
    mergeByFirstKey(obj1, obj2) {
        const result = { ...obj1 }
        // 遍历obj1所有key，存在于obj2就赋值
        Object.keys(result).forEach(key => {
            if (key in obj2) {
            result[key] = obj2[key]
            }
        })
        return result
    },
        /**
     * 清空对象中 undefined、null、空字符串 等无效属性
     * @param {Object} obj - 待处理对象
     * @param {Array} keepKeys - 要保留的属性名数组（可选）
     * @returns {Object} 处理后的新对象
     */
    removeEmptyProps(obj, keepKeys = []) {
        if (typeof obj !== 'object' || obj === null) {
        return obj;
        }
    
        const newObj = {};
        for (const key in obj) {
        // 只处理自身属性
        if (!obj.hasOwnProperty(key)) continue;
    
        const value = obj[key];
        
        // ====================== 关键：保留字段直接通过 ======================
        if (keepKeys.includes(key)) {
            newObj[key] = value;
            continue;
        }
    
        // 过滤空值：undefined、null、空字符串、空数组
        if (
            value !== undefined &&
            value !== null &&
            value !== '' &&
            // 数组判断（空数组过滤）
            !(Array.isArray(value) && value.length === 0)
        ) {
            newObj[key] = value;
        }
        }
        return newObj;
    },
}

export default {
    ...object,
    convertOnlyObjectArrayToJson:convertOnlyObjectArrayToJson,
};
